import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { UncontrolledTooltip } from 'reactstrap';
import { setOfferSupportHours, startSetOfferSupportHours } from '../../actions/offers';
import { FMessage } from '../../hoc/IntlComponents';
import Card from '../Card/Card';
import Icon from '../Icon/Icon';

const OfferSupportHours = ({ offerId, collapsing }) => {
  const { supportHours } = useSelector(state => state.offers);
  const { countries } = useSelector(state => state.app.globalSettings);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(startSetOfferSupportHours(offerId));
    return () => {
      dispatch(setOfferSupportHours([]));
    };
  }, [dispatch, offerId, setOfferSupportHours, startSetOfferSupportHours]);

  const getCountryTitle = geo => Array.isArray(countries) && countries.find(c => c.id === geo)?.title || '';
  const generateTimeString = (from = '00:00', to = '23:59') =>
    from === '00:00' && to === '23:59' ? '24/7' : `${from} - ${to}`;

  return supportHours && supportHours.length > 0 ? (
    <Card.WithControls
      title="offer.support.title"
      defaultMessage="Call-center working hours"
      collapsing={collapsing}
      hint={
        <>
          <Icon
            id="offer-support-title-tooltip"
            type="help-question"
            className="offer-support-title-tooltip-icon"
          />
          <UncontrolledTooltip target="offer-support-title-tooltip" placement="top">
            <FMessage id="offer.support.title-tootip" />
          </UncontrolledTooltip>
        </>
      }
    >
      <Card.Body>
        <div className="offer-support-hours">
          <div className="offer-support-hours-title">
            <div className="offer-support-hours-title-item">
              <FormattedMessage id="offer.support.geo" defaultMessage="Country" />
            </div>
            <div className="offer-support-hours-title-item">
              <FormattedMessage id="offer.support.hours" defaultMessage="Working hours" />
            </div>
          </div>
          <div className="offer-support-hours-body">
            {supportHours.map(item => (
              <div key={item.geo} className="offer-support-hours-body-row">
                <span>{getCountryTitle(item.geo)}</span>
                <span>{generateTimeString(item.from, item.to)}</span>
              </div>
            ))}
          </div>
        </div>
      </Card.Body>
    </Card.WithControls>
  ) : null;
};

export default OfferSupportHours;
